export class SignatureVisitModel {
  riSign: string;
  rlSign: string;

  constructor(riSign: string, rlSign: string) {
    this.riSign = riSign;
    this.rlSign = rlSign;
  }
}
